import { CSSProperties } from 'react';
import Loading from '../../components/Loading/Loading';

interface graphLoader {
  isLoading: boolean;
  style?: CSSProperties;
}

const GraphLoader: React.FC<graphLoader> = (props) => {
  const { isLoading, style } = props;
  return (
    <div style={style}>
      {/* Y-axis line */}
      <div
        style={{
          // position: 'absolute',
          top: 0,
          left: '0%',
          width: '1px',
          height: '100%',
          background: 'black',
          transform: 'translateX(-50%)',
        }}
      />

      {/* X-axis line */}
      <div
        style={{
          // position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '1px',
          background: 'black',
        }}
      />

      {/* Centered content */}
      <div
        style={{
          position: 'absolute',
          top: '57%',
          left: '54%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        {/* Your content */}
        {/* ... */}
        {isLoading ? <Loading /> : 'No Data Found'}
      </div>
    </div>
  );
};

export default GraphLoader;
